import React, { useState, useContext, useRef, useEffect } from "react"
import { Typography } from "@stardust-ds/react"
import intl from "react-intl-universal"

import styles from "./index.module.scss"
import ConfigIcon from "../../../assets/icons/ConfigIcon"
import NotificationIcon from "../../../assets/icons/NotificationIcon"
import AuthContext from "../../../contexts/Auth"
import RcmpLink from "../Link"
import useClickOutside from "../../../hooks/useClickOutside"
import { fnGetNewNotifications } from "../../../services/notifications"
import { fnBisAdmin } from "../../../utils/permissions"
import RcmpBreadCrumb from "../BreadCrumb"
import RcmpModalInfo from "../../organisms/ModalInfo"
import { fnGeStatusLogin } from "../../../services/auth"
import useDataApi from "../../../hooks/useDataApi"
import MenuHamburguerIcon from "../../../assets/icons/MenuHamburguerIcon"
import SideBarContext from "../../../contexts/SideBar"
import {
  fnDecodeStorageToken,
  fnSetStorageToken,
} from "../../../utils/encodeLocalStorage"
import { useParams } from "react-router-dom"
import { useAppearanceContext } from "../../../contexts/Appearance"

function RcmpHeaderBreadCrumb(props) {
  const { aBreadCrumbs, className } = props

  if (!aBreadCrumbs?.length) return null

  const cClass = `${styles.breadCrumbAlignment} ${className ? className : ""}}`

  return (
    <RcmpBreadCrumb className={cClass}>
      {aBreadCrumbs?.map(({ bActive, name, path }, nIndex) => (
        <RcmpBreadCrumb.RcmpItem key={nIndex} bActive={bActive} to={path}>
          {name}
        </RcmpBreadCrumb.RcmpItem>
      ))}
    </RcmpBreadCrumb>
  )
}

function RcmpHeader(props) {
  const { children, cTitlePage, elIcon, aBreadCrumbs, className, ...oRest } = props

  const [bConfigisOpen, fnSetBConfigIsOpen] = useState(false)
  const [bNewNotification, fnSetBNewNotification] = useState(false)
  const [bTrialExpired, fnSetBTrialExpired] = useState(false)

  const [oGetStatusLoginRes, fnGetStatusLoginReq] = useDataApi(fnGeStatusLogin)

  const { oUser, fnLogout } = useContext(AuthContext)
  const { fnSetBSideBarIsOpen } = useContext(SideBarContext)
  const { blockId } = useParams()
  const { oConfig: oConfigWL } = useAppearanceContext()

  const elConfigMenu = useRef(null)
  useClickOutside(elConfigMenu, () => fnSetBConfigIsOpen(false))

  function fnOpenSideBar() {
    fnSetBSideBarIsOpen(true)
  }

  function fnToogleConfigMenu() {
    fnSetBConfigIsOpen(bConfigisOpen ? false : true)
  }

  async function fnGetNewNotitificationsWithParams(bIsAutomatic) {
    const response = await fnGetNewNotifications(
      bIsAutomatic ? "bNotRenewing=false" : null,
    )
    fnSetBNewNotification(response?.data)
  }

  useEffect(() => {
    let tmInterval
      ; (async () => {
        await fnGetStatusLoginReq()
        await fnGetNewNotitificationsWithParams()

        tmInterval = setInterval(async () => {
          await fnGetNewNotitificationsWithParams(true)
        }, 60000)
      })()

    return () => {
      clearInterval(tmInterval)
    }
  }, [])

  useEffect(() => {
    if (!oGetStatusLoginRes.done) return
    fnSetBTrialExpired(false)
    if (oGetStatusLoginRes?.data && oGetStatusLoginRes?.data == "null") {
      fnSetStorageToken(oGetStatusLoginRes?.data)
    }

    if (
      !fnDecodeStorageToken()?.bActive &&
      window.location.pathname !== "/dashboard/plan"
    ) {
      // if (blockId) {
      //   localStorage.setItem("qrCodeUrl", window.location.pathname)
      // }
      window.location.href = "/dashboard/plan"
    }
    if (oGetStatusLoginRes.error?.request?.status === 403) fnSetBTrialExpired(true)
  }, [oGetStatusLoginRes])

  const cfantasyname = oUser?.data?.customer.cust_cfantasyname || ""
  const cClass = `${styles.headerContainer} ${className ? className : ""}`
  const cVersion = process.env.REACT_APP_VERSION

  const aConfigOptions = [
    {
      path: "./customer/update/",
      name: intl.get("header.costumer-update"),
    },
    {
      path: "./dashboard/plan",
      name: intl.get("header.plans"),
    },
    {
      path: "./document/configure",
      name: intl.get("header.config-footer"),
    },
  ]
  if (oConfigWL && !oConfigWL.nWlpnId) {
    aConfigOptions.push(
      {
        path: "./dashboard/extract",
        name: intl.get("header.extract"),
      },
      {
        path: "./terms",
        name: intl.get("header.terms"),
      },
    )
  }

  return (
    <div className={cClass} {...oRest}>
      <div className={styles.headerContent}>
        <MenuHamburguerIcon className={styles.menuHamburguer} onClick={fnOpenSideBar} />
        <div>
          <RcmpHeaderBreadCrumb aBreadCrumbs={aBreadCrumbs} />
          <div className={styles.headerTop}>
            {cTitlePage && (
              <div className={`${styles.titlePage} boxTitle`}>
                {elIcon && React.cloneElement(elIcon)}
                <Typography fontSize="xxl" type="h1">
                  {cTitlePage}
                </Typography>
              </div>
            )}
          </div>
        </div>
        <div className={styles.headerRight}>
          <div className={styles.headerMenu}>
            {fnBisAdmin() && (
              <div ref={elConfigMenu}>
                <ConfigIcon onClick={fnToogleConfigMenu} />
                {bConfigisOpen && (
                  <div className={styles.headerMenuOptions}>
                    {aConfigOptions.map((oOption, nIndex) => (
                      <RcmpLink key={`config-key-${nIndex}`} to={oOption?.path} exact>
                        {oOption.name}
                      </RcmpLink>
                    ))}
                    <div>
                      {intl.get("header.version", {
                        version: cVersion?.replace("v", ""),
                      })}
                    </div>
                  </div>
                )}
              </div>
            )}
            <RcmpLink to="./notification" exact>
              <NotificationIcon />
              {bNewNotification && <span className={styles.newNotification} />}
            </RcmpLink>
          </div>
          <p className={styles.userName}>{cfantasyname}</p>
        </div>
      </div>
      {React.Children.count(children) > 0 && (
        <div className={styles.headerChildren}>{children}</div>
      )}
      <RcmpModalInfo
        bIsOpen={bTrialExpired}
        title="FIM DO PERÍODO DE TRIAL"
        description="O tempo de avaliação do sistema chegou ao fim. Para continuar a utilizar o produto entre em contato com seu administrador."
        size="sm"
        buttonSaveText="OK"
        oButtonSaveProps={{ style: { margin: "0 auto" } }}
        oButtonCancelProps={{ style: { display: "none" } }}
        fnHandleConfirm={fnLogout}
      />
    </div>
  )
}

export default RcmpHeader
